import { lazy } from "react";
import { Route } from "react-router-dom";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";
import { FeatureRoute } from "@/components/common/FeatureRoute";
import { CustomPlanRedirect } from "./CustomPlanRedirect";

const GoverningDocumentsPage = lazy(() => import("@/pages/governing-documents/GoverningDocumentsPage"));
const GoverningDocumentEditPage = lazy(() => import("@/pages/governing-documents/GoverningDocumentEditPage"));
const GoverningDocumentTypesPage = lazy(() => import("@/pages/governing-documents/GoverningDocumentTypesPage"));
const GoverningDocumentReviewPage = lazy(() => import("@/pages/governing-documents/GoverningDocumentReviewPage"));

export function GoverningDocumentRoutes() {
  return (
    <>
      {/* Public review page - no auth required */}
      <Route path="/review/governing-document/:token" element={
        <GoverningDocumentReviewPage />
      } />
      <Route path="/governing-documents" element={
        <ProtectedRoute><CustomPlanRedirect>
          <FeatureRoute feature="governing_documents" featureName="Governing Documents">
            <GoverningDocumentsPage />
          </FeatureRoute>
        </CustomPlanRedirect></ProtectedRoute>
      } />
      <Route path="/governing-documents/new" element={
        <ProtectedRoute><CustomPlanRedirect>
          <FeatureRoute feature="governing_documents" featureName="Governing Documents">
            <GoverningDocumentEditPage />
          </FeatureRoute>
        </CustomPlanRedirect></ProtectedRoute>
      } />
      <Route path="/governing-documents/:id" element={
        <ProtectedRoute><CustomPlanRedirect>
          <FeatureRoute feature="governing_documents" featureName="Governing Documents">
            <GoverningDocumentEditPage />
          </FeatureRoute>
        </CustomPlanRedirect></ProtectedRoute>
      } />
      <Route path="/governing-documents/types" element={
        <ProtectedRoute><CustomPlanRedirect>
          <FeatureRoute feature="governing_documents" featureName="Governing Documents">
            <GoverningDocumentTypesPage />
          </FeatureRoute>
        </CustomPlanRedirect></ProtectedRoute>
      } />
    </>
  );
}
